import { IMPACT } from "@/data/content";
import { AnimatedCounter, Reveal } from "./primitives";

export default function ImpactBar() {
  return (
    <section className="relative border-y border-brand-navy/10 bg-brand-navy">
      <div className="noise-overlay pointer-events-none absolute inset-0 opacity-[0.04]" />
      <div className="mx-auto grid max-w-7xl grid-cols-1 px-5 sm:grid-cols-3 lg:px-8">
        {IMPACT.map((item, i) => (
          <Reveal key={item.label} delay={i * 0.08} className="px-3 py-8 text-center md:py-10">
            <p className="font-display text-4xl font-semibold tracking-tight text-brand-gold md:text-5xl">
              {item.text ? (
                item.text
              ) : (
                <>
                  <AnimatedCounter to={item.value} />
                  {item.suffix}
                </>
              )}
            </p>
            <p className="mt-2 text-xs font-bold uppercase tracking-[0.18em] text-white md:text-sm">
              {item.label}
            </p>
            <p className="mt-1 text-[11px] leading-snug text-white/50 md:text-xs">{item.sub}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
